import React from "react";
import { Card, Row, Col, Typography, Badge } from "antd";
import StatsCard from "../../../Reuseable/StatsCard/StatsCard";
import { formatWithCommas } from "../../../assets/helpers";
import './style.scss';
import { setQuery } from "../../../store/filters";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const { Title, Text } = Typography;


const IntensityCards = ({ id, loading = false, data = [] }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleNavigate = (item) => {
        dispatch(setQuery({
            intensity: item?.intensity,
            portfolio: id
        }));
        navigate(`/allocation/cases`)
    }
    return (
        <Row gutter={[16, 16]}>

            {data?.map((item) => (
                <Col xs={24} sm={12} md={8} lg={6} key={item.intensity}>
                    <div style={{ cursor: 'pointer' }} className={`${loading ? "loading-intensity-card" : ""}`} onClick={() => handleNavigate(item)}>
                        <StatsCard
                            {...{
                                title: `Intensity ${item.intensity}`,
                                value: formatWithCommas(item.count),
                                // percent:  "0%",
                                amountLabel: "",

                                type: "default",
                                loading: loading,
                            }}
                        />
                    </div>
                </Col>
            ))}
        </Row>
    );
};

export default IntensityCards;
